import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import FilterListIcon from "@mui/icons-material/FilterList";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DownloadIcon from "@mui/icons-material/DownloadOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  FormControl,
  Stack,
  FormLabel,
  Grid,
  TableContainer,
  TextareaAutosize,
  TextField,
  Box,
  Typography,
  Divider,
  IconButton,
  Chip,
  Checkbox,
  InputAdornment,
  FormControlLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Card } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import format from "date-fns/format";
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import { styled } from "@mui/material/styles";
import {
  BankTransaction,
  GetUsers,
  MutlipleAssignTxnUser,
  getBrokerBranchDetailsByBrokerBranchName,
  UploadFile,
  fetchFile,
} from "../../Services/api";
import instance from "../../redux/api";
import { BANK_STATEMENT_ROW_DATA } from "../../utils/config";
import DialogBox from "../common/dialog";
import { CommonPaginationContainer, CommonSelect, CommonFilterSidebar } from "../common";
import { CommonButton } from "../common/commonButton";
import "../common/commonPageStyles.css";
import {
  getAccountsList,
  getBrokerBranchesList,
  getCurrencyList,
} from "../../redux/slice/bankStatmentTransactionsSlice";
import "../bankTransactions/bankTransaction.css";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { AddUpload } from "./AddUpload";
import {
  numberFormatter,
} from "../../utils/generalFunctions";
import { customDateFormat, getPaginationCount } from "../CashAllocation/utils";
import { CircularProgress } from "@mui/material";
import { downloadFileModdules } from "../CashAllocation/constants";
import { commonToast } from "../common";

const dialogStyle = {
  maxWidth: "60vw",
  width: "60vw",
  margin: "auto",
};

// Modern input field styling
const modernInputStyles = {
  width: "100%",
  maxWidth: "140px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f8f9fa",
    borderRadius: "10px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "& fieldset": {
      borderColor: "rgba(22, 114, 222, 0.15)",
      borderWidth: "1.5px",
      transition: "all 0.3s ease",
    },
    "&:hover": {
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 8px rgba(22, 114, 222, 0.1)",
      "& fieldset": {
        borderColor: "rgba(22, 114, 222, 0.3)",
      },
    },
    "&.Mui-focused": {
      backgroundColor: "#ffffff",
      boxShadow: "0 0 0 3px rgba(22, 114, 222, 0.1), 0 4px 12px rgba(22, 114, 222, 0.15)",
      "& fieldset": {
        borderColor: "#1672DE",
        borderWidth: "2px",
      },
    },
    "&.Mui-disabled": {
      backgroundColor: "#f5f7fa",
      cursor: "not-allowed",
      "& fieldset": {
        borderColor: "rgba(22, 114, 222, 0.08)",
        borderWidth: "1px",
      },
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "6px 10px",
    fontSize: "11px",
    fontWeight: "500",
    color: "#263238",
    "&::placeholder": {
      color: "#90a4ae",
      opacity: 0.7,
    },
  },
};

export default function UploadFilesConatiner() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);

  const brokerBranches = useSelector(
    (state) => state?.bankStatmentTransactions?.brokerBranchesList
  );
  const dropdownValuesCurreny = useSelector(
    (state) => state?.bankStatmentTransactions?.currencyList
  );

  const dispatch = useDispatch();

  // Local State
  const [selectedOption, setSelectedOption] = useState("");
  const [isOpenAddBankTxnDialog, setIsOpenAddBankTxnDialog] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [openResetDialog, setOpenResetDialog] = useState(false);
  const [assignType, setAssignType] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogInputValue, setDialogInputValue] = useState("");
  const [
    currentPaymentReferenceIndex,
    setCurrentPaymentReferenceIndex,
  ] = useState(0);
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [uploadedStmtId, setUploadedStmtId] = useState();

  const [rows, setRows] = useState([
    { ...BANK_STATEMENT_ROW_DATA, Bank_Account_Name_Entity: selectedOption },
  ]);
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );
  const [
    currentUpdatedFiledsInEditMode,
    setCurrentUpdatedFiledsInEditMode,
  ] = useState({});

  //bank statement transaction search
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const [searchFieldsPrams, setSearchFieldsPrams] = useState({
    Bank_Name: "",
    Receiving_Bank_Account: "",
    uploaded_status: "",
  });

  const [currentRow, setCurrentRow] = useState("");
  const [txnMode, setTxnMode] = useState("VIEW");

  //File upload
  const [isFileUploadDialogOpen, setIsFileUploadDialogOpen] = useState(false);

  const handleFileUpLoadDialog = () => {
    setIsFileUploadDialogOpen(true);
  };

  //For pagination
  const [defaultPage, setDefaultPage] = useState(1);
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isBankAccountNoDeSelected, setIsBankAccountNoDeSelected] = useState(false);
  const [isUploadedStatusSelected, setIsUploadedStatusSelected] = useState(false);
  const [isBankNameSelected, setIsBankNameSelected] = useState(false);

  const [assigningToUserDetails, setAssigningToUserDetails] = useState({});

  // Add a new state variable for button click tracking
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [downloadingFile, setDownloadingFile] = useState(null);

  // Filter search states
  const [bankNameSearch, setBankNameSearch] = useState("");
  const [accountNoSearch, setAccountNoSearch] = useState("");
  const [selectedBanks, setSelectedBanks] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);

  //styles
  const classes = useStyles();
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);


  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
  };

  const uploadedStatusList = [
    { id: 1, uploaded_status: "uploaded" },
    { id: 1, uploaded_status: "rejected" },
  ];

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
      ? pageState?.page
      : pageState?.page - 1;
  };

  // Handler for Account No Dropdown
  const handleBankTnxSelectAccountDropdown = (name, value, reason) => {
    if (reason === "clear") {
      setIsBankAccountNoDeSelected(true);
    } else {
      setIsBankAccountNoDeSelected(false);
    }
    setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
  };

  const handleClearSearchList = async () => {
    // Clear all filter states
    setSelectedBanks([]);
    setSelectedAccounts([]);
    setBankNameSearch("");
    setAccountNoSearch("");
    setIsClearPerformed(true);
    setIsSearchPerformed(false);
    // clear fields
    setSearchFieldsPrams({
      Bank_Name: "",
      Receiving_Bank_Account: "",
      uploaded_status: "",
    });
    getBankAccountsList("")
    setFromDateValue("");
    setToDateValue("");
  };

  useEffect(() => {
    // Fetch users data from an API
    instance
      .get(GetUsers)
      .then((data) => {
        // setUsers(data.data);
        const filteredUsers = data.data.filter(
          (user) => user.status === "Active"
        );
        setUsers([...new Set(filteredUsers)]);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  const handleSubmitAssing = async () => {
    const assigningToInfo = users?.filter(
      (item) => item?.user_name === selectedUser
    );
    const assigningToId = assigningToInfo[0]?.id;

    try {
      if (assignType === "ASSIGN") {
        const response = await instance.patch(
          `${UploadFile}${uploadedStmtId}/`,
          { id: uploadedStmtId, allocated_analyst_id: assigningToId }
        );
        // Check if the response is successful (status code 2xx)
        if (response) {
          handleCloseDialog();
          loadData();
          // Display success notification
          commonToast("success", "Submission successful");
        } else {
          // Display error notification if response status is not in the success range
          commonToast("error", "Submission failed. Please try again.");
        }
      } else if (assignType === "UPDATE_ASSIGNMENT_DROPDOWN_VALUE") {
        handleCloseDialog();
        setAssigningToUserDetails({ ...assigningToInfo[0] });

        // Update Assignement column only for Selected Rows
        let rowsToUpdate = [...rows];
        rowsToUpdate.forEach((element) => {
          const { id } = element;
          if (selectedRows?.findIndex((item) => item.id === id) !== -1) {
            return (element.Assigned_Users[0] = assigningToInfo[0]);
          }
          return element;
        });
        // update Rows
        setRows([...rowsToUpdate]);
      }
    } catch (err) {
      // Display error notification for request failure
      commonToast("error", "Submission failed. Please try again.");
    }
  };

  const handleAssignButtonClick = (params, type) => {
    setSelectedUser("");
    setDialogOpen(true);
    setUploadedStmtId(params.row.id);
    setAssignType(type);
  };

  const handleAssignButtonInUploadDetails = () => {
    setSelectedUser("");
    setDialogOpen(true);
    setAssignType("UPDATE_ASSIGNMENT_DROPDOWN_VALUE");
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  // handle "Select All" checkbox
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectedRows(isChecked ? [...rows] : []);
    setSelectAll(isChecked);
  };

  const handleCheckboxChange = (row, isChecked) => {
    setSelectedRows((prevSelectedRows) => {
      if (isChecked) {
        const newRows = [...prevSelectedRows, row];
        if (newRows.length === rows.length) {
          setSelectAll(isChecked);
        }
        return newRows;
      } else {
        setSelectAll(isChecked);
        return prevSelectedRows.filter(
          (selectedRow) => selectedRow.id !== row.id
        );
      }
    });
  };

  useEffect(() => {
    // Fetch Banks List
    dispatch(getAccountsList());
    // Fetch Broker branches
    dispatch(getBrokerBranchesList());
    // Fetch Currency Details
    dispatch(getCurrencyList());
  }, []);

  const handleBankAccountDropdownChange = (value, reason = "") => {
    if (reason === "clear") {
      setIsUploadedStatusSelected(false);
      setSelectedOption(value);
    } else {
      setIsUploadedStatusSelected(true);
      setSelectedOption(value);
    }
  };

  // Handler for Bank Name Dropdown
  const handleBankNameDropdownChange = (name, value, reason) => {
    if (reason === "clear") {
      setIsBankNameSelected(false);
      setSearchFieldsPrams(prev => ({ ...prev, [name]: value, Receiving_Bank_Account: null })); // Also reset Account No when Bank Name is cleared
      getBankAccountsList("")
    } else {
      setIsBankNameSelected(true);
      setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
      getBankAccountsList(value)
    }
  };

  const handleActionButton = async (currentRowData, currentTxnMode) => {
    if (currentRowData.row.uploaded_status === "uploaded") {
      try {
        const id = currentRowData.row.id;
        console.log("currrent row", currentRowData);
        setUploadedStmtId(id);

        const response = await instance.get(
          `${BankTransaction}?br_id=${id}&skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize
          }`
        );

        setRows(response.data?.data);

        setCurrentRow(currentRowData);
        setTxnMode(currentTxnMode);
        setIsOpenAddBankTxnDialog(true);
      } catch (error) {
        console.error("Error:", error);
        // Handle errors here
      }
    } else {
      commonToast("error", "Error: File not uploaded");
    }
  };

  const handleReset = () => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      ...BANK_STATEMENT_ROW_DATA,
      Bank_Account_Name_Entity: selectedOption,
    }));
    setRows(emptyRows);

    setOpenResetDialog(false);
    handleBankAccountDropdownChange("");
  };

  const handleDeleteConfirmed = async () => {
    try {
      // Send DELETE request to your API
      const response = await instance.delete(UploadFile + idToDelete);

      // Check if the deletion was successful
      if (response.status === 200) {
        // If successful, show a success toast
        commonToast("success", "Transaction deleted successfully");
        setOpen(false);
        setIdToDelete(null);

        loadData();
        // If needed, update the state to reflect the deletion
        const updatedRows = rows.filter((row) => row.id !== idToDelete);
        setRows(updatedRows);
      } else {
        // If deletion was not successful, show an error toast
        commonToast("error", `Error deleting item: ${response.statusText}`);
      }
    } catch (error) {
      // If an error occurs during deletion, show an error toast
      commonToast("error", `Error deleting item: ${error.message}`);
    }
  };

  const handleDeleteCancelled = () => {
    setOpen(false);
    setIdToDelete(null);
  };

  const [banksList, setBanksList] = useState([])
  const [selectedBankAccount, setSelectedBankAccount] = useState("");

  const getBanksList = async () => {
    const response = await instance.get("documents/get_all_unique_bank_names/")
    setBanksList(response?.data?.bank_names)
  }

  const getBankAccountsList = async (value) => {
    const response = await instance.get(`documents/get_all_unique_account_numbers_by_bank_name/?bank_name=${value}`)
    setSelectedBankAccount(response?.data?.account_numbers)
  }

  useEffect(() => {
    getBanksList()
    getBankAccountsList("")
  }, [])

  const columns = [
    {
      field: "uploaded_date",
      headerName: "Uploaded Date",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            color: "#666",
            fontSize: "13px",
            fontWeight: "500",
          }}
        >
          {customDateFormat(params.row.uploaded_date)}
        </Typography>
      ),
    },
    {
      field: "file_name",
      headerName: "File Name",
      headerAlign: "center",
      minWidth: "25%",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            padding: "4px 0",
          }}
        >
          <DescriptionIcon
            sx={{
              color: "#1672DE",
              fontSize: "18px",
              flexShrink: 0,
            }}
          />
          <Typography
            variant="body2"
            sx={{
              color: "#333",
              fontWeight: "500",
              fontSize: "13px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={params.value}
          >
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "bank_account_no",
      headerName: "Account No",
      headerAlign: "center",
      align: "left",
      flex: 1.1,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            color: "#333",
            fontSize: "13px",
            fontWeight: "500",
            fontFamily: "monospace",
          }}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "bankName",
      headerName: "Bank Name",
      headerAlign: "center",
      minWidth: "5%",
      flex: 0.85,
      valueGetter: (params) => params.row?.bank_details?.bank_name,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            color: "#333",
            fontSize: "13px",
            fontWeight: "500",
          }}
        >
          {params.row?.bank_details?.bank_name ?? ""}
        </Typography>
      ),
    },
    {
      field: "file_date",
      headerName: "File Date",
      flex: 0.7,
      headerAlign: "center",
      valueGetter: (params) => params?.value,
      valueFormatter: (params) => {
        return customDateFormat(params.value);
      },
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            color: "#666",
            fontSize: "13px",
            fontWeight: "500",
          }}
        >
          {customDateFormat(params.value)}
        </Typography>
      ),
    },
    {
      field: "uploaded_status",
      headerName: "Uploaded Status",
      headerAlign: "center",
      minWidth: "10%",
      flex: 0.9,
      renderCell: (params) => {
        const status = params.value?.toLowerCase();
        const isUploaded = status === "uploaded";
        return (
          <Chip
            label={params.value || ""}
            sx={{
              backgroundColor: isUploaded 
                ? "rgba(76, 175, 80, 0.1)" 
                : "rgba(244, 67, 54, 0.1)",
              color: isUploaded ? "#4caf50" : "#f44336",
              fontWeight: "600",
              fontSize: "12px",
              height: "28px",
              borderRadius: "6px",
              border: `1px solid ${isUploaded ? "#4caf50" : "#f44336"}`,
            }}
          />
        );
      },
    },
    {
      field: "uploaded_by",
      headerName: "Uploaded By",
      headerAlign: "center",
      align: "left",
      minWidth: "10%",
      flex: 0.9,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            justifyContent: "flex-start",
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: "#1672DE",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "10px",
              fontWeight: "600",
              flexShrink: 0,
            }}
          >
            {(params.row?.uploaded_by?.user_name ?? "U").charAt(0).toUpperCase()}
          </Box>
          <Typography
            variant="body2"
            sx={{
              color: "#333",
              fontSize: "13px",
              fontWeight: "500",
            }}
          >
            {params.row?.uploaded_by?.user_name ?? ""}
          </Typography>
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      sortable: false,
      description: "This column has a value getter and is not sortable.",
      minWidth: "10%",
      flex: 0.6,
      valueGetter: (params) => params?.row?.uploaded_status,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {params?.row?.uploaded_status?.toLowerCase() === "uploaded" ? (
              <IconButton
                size="small"
                onClick={() => handleActionButton(params, "VIEW")}
                sx={{
                  color: "#1672DE",
                  padding: "8px",
                  borderRadius: "8px",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  backgroundColor: "rgba(22, 114, 222, 0.05)",
                  border: "1px solid rgba(22, 114, 222, 0.1)",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.15)",
                    transform: "scale(1.05)",
                    boxShadow: "0 4px 12px rgba(22, 114, 222, 0.2)",
                    borderColor: "rgba(22, 114, 222, 0.3)",
                  },
                  "&:active": {
                    transform: "scale(0.95)",
                  },
                }}
                title="View Details"
              >
                <VisibilityIcon fontSize="small" />
              </IconButton>
            ) : (
              <IconButton
                size="small"
                onClick={() => handleAssignButtonClick(params, "ASSIGN")}
                sx={{
                  color: "#1672DE",
                  padding: "6px",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    transform: "scale(1.1)",
                  },
                }}
                title="Assign"
              >
                <PersonOutlineIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        );
      },
    },
    {
      field: "user_name",
      headerName: "Assign To",
      headerAlign: "center",
      minWidth: "10%",
      flex: 0.8,
      valueGetter: (params) => params?.row?.allocated_analyst_id?.user_name,
      renderCell: (params) => (
        params?.value ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              sx={{
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                backgroundColor: "#4caf50",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "10px",
                fontWeight: "600",
                flexShrink: 0,
              }}
            >
              {params.value.charAt(0).toUpperCase()}
            </Box>
            <Typography
              variant="body2"
              sx={{
                color: "#333",
                fontSize: "13px",
                fontWeight: "500",
              }}
            >
              {params.value}
            </Typography>
          </Box>
        ) : (
          <Typography
            variant="body2"
            sx={{
              color: "#999",
              fontSize: "13px",
              fontStyle: "italic",
            }}
          >
            Not assigned
          </Typography>
        )
      ),
    },
    {
      field: "error_message",
      headerName: "Description",
      headerAlign: "center",
      align: "left",
      flex: 1,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            color: params.value ? "#f44336" : "#666",
            fontSize: "13px",
            fontStyle: params.value ? "normal" : "italic",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }}
          title={params.value || "No description"}
        >
          {params.value || "—"}
        </Typography>
      ),
    },
  ];

  const handleDialogClose = () => {
    setIsOpenAddBankTxnDialog(false);
    setSelectedRows([]);
  };

  const searchQueryParams = () => {
    let getSearchQueryParams = "";

    const { uploaded_status } = searchFieldsPrams;

    // Handle single bank name selection (only first one is sent to backend)
    if (selectedBanks.length > 0) {
      getSearchQueryParams = `${getSearchQueryParams}&bankName=${selectedBanks[0]}`;
    }

    // Handle single account number selection (only first one is sent to backend)
    if (selectedAccounts.length > 0) {
      getSearchQueryParams = `${getSearchQueryParams}&accountNo=${selectedAccounts[0]}`;
    }

    if (uploaded_status) {
      getSearchQueryParams = `${getSearchQueryParams}&uploadedStatus=${uploaded_status}`;
    }

    let formattedFromDateValue = "",
      formattedToDateValue = "";

    if (fromDateValue && toDateValue) {
      formattedFromDateValue = format(fromDateValue, "dd/MM/yyyy");
      formattedToDateValue = format(toDateValue, "dd/MM/yyyy");
      getSearchQueryParams = `${getSearchQueryParams}&fromDate=${formattedFromDateValue}&toDate=${formattedToDateValue}`;
    }

    return getSearchQueryParams;
  }

  const loadSearchTxnData = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const getSearchQueryParam = searchQueryParams();
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`;
      }

      queryParams = `${queryParams}&uploaded_statements=1`;

      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${UploadFile}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ? response?.data?.data : [],
          page: 1,
        }));
        setIsSearchPerformed(true);
        setIsClearPerformed(false);
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count ?? 0,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      console.log("err", err);
    }
  };

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      }

      queryParams = `${queryParams}&uploaded_statements=1`;

      const resp = await instance.get(`${UploadFile}?${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (resp.status === 200) {
        setPageState((old) => ({
          ...old,
          total: resp?.data?.count,
          data: resp?.data?.data ? resp?.data?.data : [],
        }));
      } else {
        setPageState((old) => ({
          ...old,
          total: resp?.data?.count,
          data: [],
        }));
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      console.error("err", err);
    }
  };

  const handleSubmitButtonEnable = () => {
    let isDisabled = true;
    if (selectedRows?.length > 0) {
      selectedRows.forEach((element) => {
        const filteredList = rows.filter((item) => item.id === element?.id);
        if (filteredList?.length > 0) {
          if (filteredList[0].Assigned_Users[0]?.user_name === selectedUser) {
            isDisabled = false;
          } else {
            isDisabled = true;
          }
        }
      });
    }
    return isDisabled;
  };

  const handleSubmit = async () => {
    setIsSubmitClicked(true); // Disable the button on click
    // get selected user id
    const assigningToInfo = users?.filter(
      (item) => item?.user_name === selectedUser
    );
    const assigningToId = assigningToInfo[0]?.id;

    // req body
    const payload = {
      user_login_id: assigningToId,
      Bank_Transaction_Ids: selectedRows.map((row) => ({ id: row.id })),
    };
    try {
      let response = await instance.post(MutlipleAssignTxnUser, payload);
      // Check if the response is successful (status code 2xx)
      if (response.status >= 200 && response.status < 300) {
        handleDialogClose();
        loadData();
        // Display success notification
        commonToast("success", "Submission successful");
      } else {
        // Display error notification if response status is not in the success range
        commonToast("error", "Submission failed. Please try again.");
      }
    } catch (err) {
      // Display error notification for request failure
      commonToast("error", "Submission failed. Please try again.");
    }
    setIsSubmitClicked(false); // Re-enable the button after submit is complete
  };

  const handleInputChange = (index, colName, value) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      updatedRows[index][colName] = value;
      setRows(updatedRows);
      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };

  const handleBrokerBranchDropdown = (index, colName, value, reason, event) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      updatedRows[index][colName] = value;
      // get broker_information (Add Mode)
      instance
        .post(getBrokerBranchDetailsByBrokerBranchName, {
          Broker_Branch_Name: value,
        })
        .then((response) => {
          updatedRows[index]["broker_information"] = response?.data?.id;
          setRows(JSON.parse(JSON.stringify(updatedRows)));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };

  const handlePaymentReferenceOpenDialog = (
    curindex,
    currentRowPaymentRefData
  ) => {
    setOpenDialog(true);
    setDialogInputValue(currentRowPaymentRefData);
    setCurrentPaymentReferenceIndex(curindex);
  };

  const handleCloseDialogs = () => {
    setOpenDialog(false);
  };

  const handleSavePaymentReference = () => {
    setOpenDialog(false);
    handleInputChange(
      currentPaymentReferenceIndex,
      "Payment_Reference",
      dialogInputValue
    ); // Pass the index parameter
  };

  const handleDialogInputChange = (e) => {
    setDialogInputValue(e.target.value);
  };

  const handleBlur = (index, colName, value) => {
    // If the value is float
    if (!Number.isInteger(value)) {
      switch (colName) {
        case "Bank_Charges":
        case "Bank_Exchange_Charges":
        case "Receivable_Amount":
          value = parseFloat(value).toFixed(2);
          break;
        case "Bank_Exchange_Rate":
          value = parseFloat(value).toFixed(6);
          break;
        default:
      }
    }

    const updatedRows = [...rows];
    updatedRows[index][colName] = value;
    setRows(updatedRows);
  };

  // Handlers for checkbox filters - Single selection enforced
  const handleBankCheckboxChange = (bankName) => {
    setSelectedBanks((prev) => {
      if (prev.includes(bankName)) {
        // Deselect if already selected
        return prev.filter((b) => b !== bankName);
      } else {
        // Replace previous selection with new one (single selection)
        return [bankName];
      }
    });
  };

  const handleAccountCheckboxChange = (accountNo) => {
    setSelectedAccounts((prev) => {
      if (prev.includes(accountNo)) {
        // Deselect if already selected
        return prev.filter((a) => a !== accountNo);
      } else {
        // Replace previous selection with new one (single selection)
        return [accountNo];
      }
    });
  };

  const handleUploadedStatusClick = (status) => {
    setSearchFieldsPrams((prev) => ({
      ...prev,
      uploaded_status: prev.uploaded_status === status ? "" : status,
    }));
  };

  const handleClearBankSearch = () => {
    setBankNameSearch("");
    setSelectedBanks([]);
  };

  const handleClearAccountSearch = () => {
    setAccountNoSearch("");
    setSelectedAccounts([]);
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { uploaded_status } = searchFieldsPrams;
    if (
      selectedBanks.length > 0 ||
      selectedAccounts.length > 0 ||
      uploaded_status !== "" ||
      fromDateValue !== "" ||
      toDateValue !== ""
    ) {
      disabled = false;
    }
    return disabled;
  };

  useEffect(() => {
    setPaginationCount(getPaginationCount(pageState?.total, pageState?.pageSize));
  }, [pageState?.total]);

  // UseEffect
  useEffect(() => {
    if (isBankAccountNoDeSelected || isClearPerformed || !isUploadedStatusSelected || !isBankNameSelected) {
      loadData();
    }
  }, [isBankAccountNoDeSelected, isClearPerformed, isUploadedStatusSelected, isBankNameSelected]);

  useEffect(() => {
    if (!isBankAccountNoDeSelected) {
      loadData();
    }
  }, [pageState?.pageSize, pageState?.page]);

  const handleDownloadClick = async (bucketKey, documentName) => {
    try {
      setDownloadingFile(bucketKey, documentName);
      const module = downloadFileModdules.uploadedFiles;
      const url = `${fetchFile}?key=${bucketKey}&module=${module}`;
  
      const response = await instance.get(url, { responseType: "blob" });
      const contentType = response.headers["content-type"];
      const blob = new Blob([response.data], { type: contentType });
      const fileURL = window.URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = documentName || "download";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileURL);

      showToast("success", "File downloaded successfully.");
    } catch (error) {
      showToast("error", "Failed to download the file.");
    } finally {
      setDownloadingFile(null);
    }
  }

  const showToast = (type, message) => {
    toast[type](message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
    });
  };

  // const handleViewDownloadClick=()=>{
  //   instance.get(`${getBankReconciliationView}`)
  //   .then(response=>console.log("res viw", response))
  // }
  
  const handleEnter = (e) => {
    if (e.code === "Enter") {
      loadSearchTxnData();
    }
  };

  return (
    <div style={Container}>
      {/* Filter Sidebar */}
      <CommonFilterSidebar
        isOpen={filterSidebarOpen}
        filterConfigs={[
          {
            type: "bankName",
            label: "Bank Name",
            placeholder: "Search banks",
            searchValue: bankNameSearch,
            onSearchChange: setBankNameSearch,
            items: banksList || [],
            selectedItems: selectedBanks,
            onItemChange: handleBankCheckboxChange,
            onClear: handleClearBankSearch,
            singleSelection: true, // Enable single selection mode
          },
          {
            type: "accountNo",
            label: "Account No",
            placeholder: "Search accounts",
            searchValue: accountNoSearch,
            onSearchChange: setAccountNoSearch,
            items: selectedBankAccount || [],
            selectedItems: selectedAccounts,
            onItemChange: handleAccountCheckboxChange,
            onClear: handleClearAccountSearch,
            singleSelection: true, // Enable single selection mode
          },
          {
            type: "custom",
            content: (
              <>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#000",
                marginBottom: "12px",
              }}
            >
              Uploaded Status
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              {(uploadedStatusList?.map(
                (option) => option?.uploaded_status
              ) || []).map((status) => (
                <Typography
                  key={status}
                  onClick={() => handleUploadedStatusClick(status)}
                  sx={{
                    fontSize: "14px",
                    color: "#000",
                    cursor: "pointer",
                    padding: "4px 0",
                    fontWeight:
                      searchFieldsPrams?.uploaded_status === status ? "600" : "400",
                    "&:hover": {
                      color: "#1672DE",
                    },
                  }}
                >
                  {status}
                </Typography>
              ))}
            </Box>
              </>
            ),
          },
          {
            type: "dateRange",
            label: "File Period",
            startDate: fromDateValue,
            setStartDate: setFromDateValue,
            endDate: toDateValue,
            setEndDate: setToDateValue,
            maxDate: new Date(),
            onKeyUp: handleEnter,
          },
        ]}
        onApplyFilters={loadSearchTxnData}
        onClearFilters={handleClearSearchList}
        isLoading={pageState?.isLoading}
        isFilterDisabled={isFilterBtnDisable()}
      />

      {/* Main Content Area */}
      <Box className="main-content-area">
        <Box className="page-header-container">
          <Typography
            variant="h5"
            className="page-heading"
          >
            Uploaded Statements
          </Typography>
          <IconButton
            onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
            className="filter-toggle-button"
          >
            <FilterListIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            position: "relative",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "visible",
            transition: "all 0.3s ease",
            border: "1px solid #e8eaf0",
            paddingBottom: "10px",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            },
        }}
      >
        <DataGrid
          className={classes.pagination}
          loading={pageState?.isLoading}
          rows={pageState?.data ?? []}
          rowCount={pageState?.total}
          columns={columns}
          keepNonExistentRowsSelected
          startIcon={<AddIcon />}
          pagination
          paginationMode="server"
          getRowId={(row) => row?.id}
          disableSelectionOnClick
          page={pageState.page - 1}
          pageSize={pageState?.pageSize ?? 25}
          pageSizeOptions
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageSizeChange={(newPageSize) => {
            return setPageState((old) => {
                setPaginationCount(
                  getPaginationCount(pageState?.total, newPageSize)
                );
              setDefaultPage(1);
              return { ...old, pageSize: newPageSize, page: 1 };
            });
          }}
          sx={{
              border: "none",
              flex: 1,
              minHeight: 0,
              "& .MuiDataGrid-root": {
                border: "none",
                height: "100%",
              },
              "& .MuiDataGrid-main": {
                height: "100%",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "transparent",
                fontWeight: "600",
                color: "#1672DE",
                fontSize: "14px",
                padding: "12px 16px",
                borderBottom: "none",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "600",
                  fontSize: "14px",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "#1672DE",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "#1672DE",
                },
              },
              "& .MuiDataGrid-row": {
                transition: "all 0.2s ease",
                borderBottom: "1px solid #f0f0f0",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.04)",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(22, 114, 222, 0.08)",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.12)",
                  },
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafafa",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04)",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #f0f0f0",
                padding: "12px 16px",
                fontSize: "13px",
                color: "#333",
                display: "flex",
                alignItems: "center",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
                "&[data-field='bank_account_no'], &[data-field='uploaded_by']": {
                  justifyContent: "flex-start",
                },
              },
            "& .MuiDataGrid-columnHeader[data-field='error_message']": {
                minWidth: "191px !important",
              },
              "& .MuiDataGrid-virtualScroller": {
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "2px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                minHeight: "48px",
                maxHeight: "48px",
                paddingBottom: "8px",
                paddingTop: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                position: "relative",
                zIndex: 1,
                "& .MuiTablePagination-root": {
                  color: "#666",
                  paddingRight: "16px",
                  margin: 0,
                  minHeight: "32px",
                },
                "& .MuiTablePagination-selectLabel": {
                  fontSize: "13px",
                  margin: 0,
                },
                "& .MuiTablePagination-displayedRows": {
                  fontSize: "13px",
                  margin: 0,
                },
                "& .MuiTablePagination-actions": {
                  marginLeft: "8px",
                  "& .MuiIconButton-root": {
                    padding: "4px",
                  },
                },
                "& .MuiTablePagination-select": {
                  margin: "0 8px",
                  padding: "4px 8px",
                },
                "& .MuiTablePagination-toolbar": {
                  minHeight: "32px",
                  padding: 0,
                },
              },
              "& .MuiDataGrid-toolbarContainer": {
                padding: "12px 16px",
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                "& .MuiButton-root": {
                  color: "#1672DE",
                  fontSize: "13px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                  },
                },
              },
              "& .MuiDataGrid-loadingOverlay": {
                backgroundColor: "rgba(255, 255, 255, 0.8)",
            },
          }}
          components={{
              Toolbar: GridToolbarContainer,
            NoRowsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ color: "#999" }}
                >
                  <Typography variant="body2" sx={{ color: "#999" }}>
                    No Transactions Found
                  </Typography>
              </Stack>
            ),
          }}
        />
        <Stack
          sx={{
            position: "absolute",
            bottom: "16px",
            right: "20px",
            zIndex: 10,
            backgroundColor: "#f8f9fa",
            padding: "4px 8px",
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <CommonPaginationContainer
            count={paginationCount + 1}
            pageState={pageState}
            setPageState={setPageState}
          />
        </Stack>
        </Box>
      </Box>

      <Dialog
        open={isOpenAddBankTxnDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{ 
          style: {
            ...dialogStyle,
            borderRadius: "16px",
            boxShadow: "0 8px 32px rgba(22, 114, 222, 0.15)",
            overflow: "hidden",
          }
        }}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "16px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle 
          id="alert-dialog-title" 
          sx={{ 
            cursor: "default",
            backgroundColor: "#ffffff",
            color: "#1672DE",
            padding: "14px 20px",
            fontWeight: "600",
            fontSize: "18px",
            letterSpacing: "0.3px",
            position: "relative",
            borderTop: "4px solid #1672DE",
            borderBottom: "1px solid rgba(22, 114, 222, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DescriptionIcon sx={{ fontSize: "20px", color: "#1672DE" }} />
            <Typography 
              variant="h6" 
              sx={{ 
                color: "#1672DE",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
              }}
            >
              Bank File Upload Details
            </Typography>
          </Box>
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            sx={{
              color: "#1672DE",
              padding: "6px",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "rgba(22, 114, 222, 0.1)",
                transform: "rotate(90deg)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ 
            overflowX: "hidden", 
            padding: "20px",
            backgroundColor: "#ffffff",
          }}
        >
          <Grid display={"flex"} flexDirection={"column"} gap={1}>
            <Card 
              elevation={0}
              sx={{
                borderRadius: "12px",
                padding: "12px",
                backgroundColor: "#ffffff",
                boxShadow: "0 2px 8px rgba(22, 114, 222, 0.08)",
                border: "1px solid rgba(22, 114, 222, 0.1)",
              }}
            >
              <Grid container className="EditpageContainerItems" spacing={1}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                  sx={{ paddingRight: "8px" }}
                >
                  <FormLabel sx={{ color: "#263238", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
                    Uploaded Date
                  </FormLabel>
                  <TextField
                    value={customDateFormat(
                      currentRow?.row?.uploaded_date ?? ""
                    )}
                    sx={{ 
                      width: "100%",
                      maxWidth: "140px",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f8f9fa",
                        borderRadius: "10px",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        "& fieldset": {
                          borderColor: "rgba(22, 114, 222, 0.15)",
                          borderWidth: "1.5px",
                          transition: "all 0.3s ease",
                        },
                        "&:hover": {
                          backgroundColor: "#ffffff",
                          boxShadow: "0 2px 8px rgba(22, 114, 222, 0.1)",
                          "& fieldset": {
                            borderColor: "rgba(22, 114, 222, 0.3)",
                          },
                        },
                        "&.Mui-focused": {
                          backgroundColor: "#ffffff",
                          boxShadow: "0 0 0 3px rgba(22, 114, 222, 0.1), 0 4px 12px rgba(22, 114, 222, 0.15)",
                          "& fieldset": {
                            borderColor: "#1672DE",
                            borderWidth: "2px",
                          },
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#f5f7fa",
                          cursor: "not-allowed",
                          "& fieldset": {
                            borderColor: "rgba(22, 114, 222, 0.08)",
                            borderWidth: "1px",
                          },
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "6px 10px",
                        fontSize: "11px",
                        fontWeight: "500",
                        color: "#263238",
                        "&::placeholder": {
                          color: "#90a4ae",
                          opacity: 0.7,
                        },
                      },
                    }}
                    size="small"
                    disabled={true}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                  sx={{ paddingRight: "8px" }}
                >
                  <FormLabel sx={{ color: "#263238", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
                    Account
                  </FormLabel>
                  <TextField
                    value={currentRow?.row?.bank_account_no ?? ""}
                    sx={{ 
                      width: "100%",
                      maxWidth: "140px",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f8f9fa",
                        borderRadius: "10px",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        "& fieldset": {
                          borderColor: "rgba(22, 114, 222, 0.15)",
                          borderWidth: "1.5px",
                          transition: "all 0.3s ease",
                        },
                        "&:hover": {
                          backgroundColor: "#ffffff",
                          boxShadow: "0 2px 8px rgba(22, 114, 222, 0.1)",
                          "& fieldset": {
                            borderColor: "rgba(22, 114, 222, 0.3)",
                          },
                        },
                        "&.Mui-focused": {
                          backgroundColor: "#ffffff",
                          boxShadow: "0 0 0 3px rgba(22, 114, 222, 0.1), 0 4px 12px rgba(22, 114, 222, 0.15)",
                          "& fieldset": {
                            borderColor: "#1672DE",
                            borderWidth: "2px",
                          },
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#f5f7fa",
                          cursor: "not-allowed",
                          "& fieldset": {
                            borderColor: "rgba(22, 114, 222, 0.08)",
                            borderWidth: "1px",
                          },
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "6px 10px",
                        fontSize: "11px",
                        fontWeight: "500",
                        color: "#263238",
                        "&::placeholder": {
                          color: "#90a4ae",
                          opacity: 0.7,
                        },
                      },
                    }}
                    size="small"
                    disabled={true}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                  sx={{ paddingRight: "8px" }}
                >
                  <FormLabel sx={{ color: "#263238", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
                    Bank Currency
                  </FormLabel>
                  <TextField
                    value={rows[0]?.Bank_Currency_Code ?? ""}
                    sx={{ 
                      width: "100%",
                      maxWidth: "140px",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f8f9fa",
                        borderRadius: "10px",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        "& fieldset": {
                          borderColor: "rgba(22, 114, 222, 0.15)",
                          borderWidth: "1.5px",
                          transition: "all 0.3s ease",
                        },
                        "&:hover": {
                          backgroundColor: "#ffffff",
                          boxShadow: "0 2px 8px rgba(22, 114, 222, 0.1)",
                          "& fieldset": {
                            borderColor: "rgba(22, 114, 222, 0.3)",
                          },
                        },
                        "&.Mui-focused": {
                          backgroundColor: "#ffffff",
                          boxShadow: "0 0 0 3px rgba(22, 114, 222, 0.1), 0 4px 12px rgba(22, 114, 222, 0.15)",
                          "& fieldset": {
                            borderColor: "#1672DE",
                            borderWidth: "2px",
                          },
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#f5f7fa",
                          cursor: "not-allowed",
                          "& fieldset": {
                            borderColor: "rgba(22, 114, 222, 0.08)",
                            borderWidth: "1px",
                          },
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "6px 10px",
                        fontSize: "11px",
                        fontWeight: "500",
                        color: "#263238",
                        "&::placeholder": {
                          color: "#90a4ae",
                          opacity: 0.7,
                        },
                      },
                    }}
                    size="small"
                    disabled={true}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                  sx={{ paddingRight: "8px" }}
                >
                  <FormLabel sx={{ color: "#263238", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
                    Bank Name
                  </FormLabel>
                  <TextField
                    value={rows[0]?.bank_details?.bank_name ?? ""}
                    sx={modernInputStyles}
                    size="small"
                    disabled={true}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                  sx={{ paddingRight: "8px" }}
                >
                  <FormLabel sx={{ color: "#263238", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
                    Entity Name
                  </FormLabel>
                  <TextField
                    value={rows[0]?.bank_details?.entity_number ?? ""}
                    sx={modernInputStyles}
                    size="small"
                    disabled={true}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                  sx={{ paddingRight: "8px" }}
                >
                  <FormLabel sx={{ color: "#263238", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
                    Bank amount CR total
                  </FormLabel>
                  <TextField
                    value={numberFormatter(currentRow?.row?.credit_amount ?? 0)}
                    sx={modernInputStyles}
                    size="small"
                    disabled={true}
                    className="right-align"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                  sx={{ paddingRight: "8px" }}
                >
                  <FormLabel sx={{ color: "#263238", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
                    Bank amount DB total
                  </FormLabel>
                  <TextField
                    value={numberFormatter(currentRow?.row?.debit_amount ?? 0)}
                    sx={modernInputStyles}
                    size="small"
                    disabled={true}
                    className="right-align"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                  sx={{ paddingRight: "8px" }}
                >
                  <FormLabel sx={{ color: "#263238", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
                    Total Balance
                  </FormLabel>
                  <TextField
                    value={numberFormatter(currentRow?.row?.total_amount ?? 0)}
                    sx={modernInputStyles}
                    size="small"
                    disabled={true}
                    className="right-align"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.4}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                  sx={{ paddingRight: "8px" }}
                >
                  <FormLabel sx={{ color: "#263238", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
                    Uploaded File
                  </FormLabel>
                  <Box
                    component="a"
                    href={currentRow?.row?.file_name_hyperlink}
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault(); 
                      handleDownloadClick(currentRow?.row?.file_name_hyperlink, currentRow?.row?.file_name) 
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      marginTop: "-2px",
                      padding: "4px 8px",
                      backgroundColor: "#e3f2fd",
                      borderRadius: "8px",
                      border: "1px solid rgba(22, 114, 222, 0.2)",
                      color: "#1672DE",
                      textDecoration: "none",
                      fontWeight: "500",
                      fontSize: "11px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      maxWidth: "100%",
                      minHeight: "32px",
                      height: "32px",
                      boxSizing: "border-box",
                      "&:hover": {
                        backgroundColor: "rgba(22, 114, 222, 0.1)",
                        borderColor: "rgba(22, 114, 222, 0.3)",
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 12px rgba(22, 114, 222, 0.15)",
                      },
                    }}
                  >
                    {downloadingFile === currentRow?.row?.file_name_hyperlink ? (
                      <CircularProgress
                        size={12}
                        sx={{ color: "#1672DE", mr: 0.5 }}
                      />
                    ) : (
                      <DownloadIcon sx={{ mr: 0.5, fontSize: "12px" }} />
                    )}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#1672DE",
                        fontWeight: "500",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: "11px",
                        lineHeight: "1.4",
                      }}
                    >
                      {currentRow?.row?.file_name}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Box
            sx={{
              borderRadius: "12px",
              padding: "16px",
              backgroundColor: "#ffffff",
              boxShadow: "0 4px 16px rgba(22, 114, 222, 0.08)",
              border: "1px solid rgba(22, 114, 222, 0.1)",
              mt: 1.5,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "12px",
                mb: 2,
              }}
            >
              <CommonButton
                sx={{
                  background: selectedRows.length === 0 ? "#CCCCCC" : "#1672DE",
                  color: "white",
                  borderRadius: "8px",
                  padding: "8px 24px",
                  minWidth: "100px",
                  fontWeight: "500",
                  transition: "all 0.3s ease",
                  boxShadow: selectedRows.length === 0 ? "none" : "0 2px 8px rgba(22, 114, 222, 0.2)",
                  "&:hover": {
                    background: selectedRows.length === 0 ? "#CCCCCC" : "#1565c0",
                    boxShadow: selectedRows.length === 0 ? "none" : "0 4px 12px rgba(22, 114, 222, 0.3)",
                    transform: selectedRows.length === 0 ? "none" : "translateY(-2px)",
                  },
                }}
                text="Assign"
                handleClick={handleAssignButtonInUploadDetails}
                disabled={selectedRows.length === 0}
                hoverColor="#1565c0"
              />
            </Box>

            <TableContainer 
              sx={{ 
                maxHeight: "300px",
                overflow: "hidden",
                marginTop: "10px",
                borderRadius: "8px",
                border: "1px solid rgba(22, 114, 222, 0.1)",
              }}
            >
              <AddUpload
                selectAll={selectAll}
                handleInputChange={handleInputChange}
                handleSelectAll={handleSelectAll}
                rows={rows}
                // setRows={setRows}
                handleBlur={handleBlur}
                handleCheckboxChange={handleCheckboxChange}
                // handleBrokerBranchDropdown={handleBrokerBranchDropdown}
                // viewMode={viewMode}
                validationStatus={validationStatus}
                dropdownValuesCurreny={dropdownValuesCurreny}
                // brokerBranches={brokerBranches}
                // txnData={currentRow}
                handlePaymentReferenceOpenDialog={
                  handlePaymentReferenceOpenDialog
                }
                selectedRows={selectedRows}
              />
            </TableContainer>
          </Box>
        </DialogContent>

        <DialogActions 
          sx={{ 
            padding: "16px 20px",
            backgroundColor: "#f8f9fa",
            borderTop: "1px solid rgba(22, 114, 222, 0.1)",
            gap: "10px",
          }}
        >
          <CommonButton
            text="Cancel"
            handleClick={handleDialogClose}
            disabled={editMode}
            sx={{
              backgroundColor: "transparent",
              color: "#1672DE",
              border: "1px solid #1672DE",
              borderRadius: "8px",
              padding: "10px 24px",
              fontWeight: "500",
              minWidth: "100px",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "rgba(22, 114, 222, 0.05)",
                borderColor: "#1565c0",
                color: "#1565c0",
              },
            }}
          />
          <CommonButton
            text="Submit"
            handleClick={handleSubmit}
            hoverColor="#1565c0"
            disabled={isSubmitClicked || handleSubmitButtonEnable()}
            sx={{
              backgroundColor: (isSubmitClicked || handleSubmitButtonEnable()) ? "#CCCCCC" : "#1672DE",
              color: "white",
              borderRadius: "8px",
              padding: "10px 24px",
              fontWeight: "500",
              minWidth: "100px",
              transition: "all 0.3s ease",
              boxShadow: (isSubmitClicked || handleSubmitButtonEnable()) ? "none" : "0 2px 8px rgba(22, 114, 222, 0.2)",
              "&:hover": {
                backgroundColor: (isSubmitClicked || handleSubmitButtonEnable()) ? "#CCCCCC" : "#1565c0",
                boxShadow: (isSubmitClicked || handleSubmitButtonEnable()) ? "none" : "0 4px 12px rgba(22, 114, 222, 0.3)",
                transform: (isSubmitClicked || handleSubmitButtonEnable()) ? "none" : "translateY(-2px)",
              },
            }}
          />
        </DialogActions>
      </Dialog>

      <DialogBox
        title="Assign To"
        body={
          <FormControl style={{ width: "100%" }}>
            <label style={{ marginBottom: 10 }}>Assigning to</label>
            <CommonSelect
              name="assigning"
              value={selectedUser}
              handleChange={(event, value, reason) =>
                setSelectedUser(value, reason)
              }
              options={users?.map((option) => option?.user_name)}
            />
          </FormControl>
        }
        confirmText="Assign"
        isOpen={isDialogOpen}
        onCancel={handleCloseDialog}
        onConfirm={handleSubmitAssing}
        isDisableConfirm={selectedUser?.length > 0 ? false : true}
      />
      <Dialog open={openDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Payment Reference</DialogTitle>
        <DialogContent sx={{ overflow: "hidden" }}>
          <TextareaAutosize
            minRows={5}
            value={dialogInputValue}
            onChange={handleDialogInputChange}
            className="PaymentReferenceDialogue"
            disabled={true}
          />
        </DialogContent>
        <DialogActions>
          <CommonButton
            text="Cancel"
            handleClick={handleCloseDialogs}
            sx={{
              backgroundColor: "#ffff",
              color: "#000000",
              border: "1px solid #BCBDBF",
            }}
          />
          <CommonButton
            text="Save"
            handleClick={handleSavePaymentReference}
            hoverColor="#1565c0"
            disabled={true}
          />
        </DialogActions>
      </Dialog>

      <DialogBox
        title="Delete Confirmation"
        body="Are you sure you want to delete this item?"
        confirmText="Delete"
        isOpen={open}
        onCancel={handleDeleteCancelled}
        onConfirm={handleDeleteConfirmed}
      />

      <DialogBox
        title="Reset Confirmation"
        body="Are you sure you want to reset?"
        confirmText="Yes"
        cancelText="No"
        isOpen={openResetDialog}
        onCancel={() => setOpenResetDialog(false)}
        onConfirm={handleReset}
      />
    </div>
  );
}
